import { useState } from 'react';

export const useComboStyleForm = () => {
  const [openBackgroundDrawer, setOpenBackgroundDrawer] = useState(false);
  const [openTitleDrawer, setOpenTitleDrawer] = useState(false);
  const [openSettingsDrawer, setOpenSettingsDrawer] = useState(false);
  const [openProductsDrawer, setOpenProductsDrawer] = useState(false);

  const onToggleBackgroundDrawer = () =>
    setOpenBackgroundDrawer(!openBackgroundDrawer);

  const onToggleTitleDrawer = () => setOpenTitleDrawer(!openTitleDrawer);

  const onToggleSettingsDrawer = () =>
    setOpenSettingsDrawer(!openSettingsDrawer);

  const onToggleProductsDrawer = () =>
    setOpenProductsDrawer(!openProductsDrawer);

  return {
    openBackgroundDrawer,
    openTitleDrawer,
    openSettingsDrawer,
    openProductsDrawer,
    onToggleBackgroundDrawer,
    onToggleTitleDrawer,
    onToggleSettingsDrawer,
    onToggleProductsDrawer,
  };
};
